import { useCallback, useState, useEffect } from 'react'

import { GET_SALE_TYPES, convertResult } from 'app/common/api/requests/food/items/sale_types/get'
import { SaleType } from 'app/dataTypes/dishes/saleType'
import { api } from 'app/api'


export function useSaleTypesMain() {
  const [loading, setLoading] = useState(true)
  const [saleTypesState, setSaleTypesState] = useState<Record<string, SaleType>>({})

  const handleRequestSaleTypes = useCallback(async () => {
    setLoading(true)
    const res = await api.request(GET_SALE_TYPES, {
      error: 'Не удалось получить типы продукции',
      convertions: {
        convertResult,
      },
    })
    setLoading(false)

    if (res) {
      setSaleTypesState(res.reduce((acc, saleType) => {
        const { id } = saleType
        acc[id] = saleType
        return acc
      }, {} as Record<string, SaleType>))
    }
  }, [])

  useEffect(() => {
    handleRequestSaleTypes()
  }, [handleRequestSaleTypes])

  return {
    loading,
    saleTypesState,
    setSaleTypesState,
    requestSaleTypes: handleRequestSaleTypes,
  }
}
